<template>
  <!-- <page :title="i18n.title"> -->
  <div class="home"></div>
  <!-- </page> -->
</template>

<script>
import { mapState } from "vuex";
import { QR_CODE } from "../../apis/cabinet";
import { TOURIST_LOGIN, USER_INFO } from "../../apis/user";
export default {
  components: {},
  data() {
    return {
      isQrcodeLink: false
    };
  },
  computed: {
    ...mapState(["user", "token", "browser", "qrcode", "mificode", "urlcode"]),
    i18n() {
      return this.$t("map");
    },
    i18nHome() {
      return this.$t("home");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    code() {
      return (
        this.$route.query.qr ||
        this.$route.query.qrcode ||
        this.$route.query.zhcode
      );
    }
  },
  watch: {},
  methods: {
    onScan(urlcode) {
      this.$loading(true);
      let query = `url=${encodeURIComponent(urlcode)}`;
      if (this.code) {
        query = `id=${this.code}`;
      }
      this.$post(
        `${QR_CODE}?${query}`,
        {},
        resp => {
          this.$loading(false);
          if (this.user && this.urlcode && !this.urlcode.includes("wifi.")) {
            console.log("urlcode1111", this.urlcode);
            this.$store.commit("urlcode", ""); // 用户登录后使用了url换取设备码就清除
          }
          if (resp.zujieNum && resp.zujieNum > 0 && !resp.haveMifiBattery) {
            this.$confirm({
              title: this.i18nHome.msg_fail_title,
              content: `${this.i18nHome.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.replace({ name: "pastOrder" });
              })
              .catch(() => {
                this.$router.replace({ name: "homeMap" });
              });
          } else if (resp.shopid) {
            // 机柜码
            this.$store.commit("cabinet", {
              qrcode: resp.cabinetID,
              ...resp
            });
            this.$store.commit("mificode", resp.cabinetID);
            this.$store.commit("mifiPackage", "");
            this.$router.replace({ name: "selectPakage" });
          } else if (resp.data) {
            // mifi设备码
            this.$store.commit("mificode", urlcode);
            this.$router.replace({ name: "packageDetail" });
            this.$store.commit("homePathName", "packageDetail");
          } else {
            this.$store.commit("cabinet", {
              qrcode: resp.cabinetID,
              ...resp
            });
            this.$store.commit("mificode", resp.cabinetID);
            this.$router.replace({
              name: "selectPakage",
              query: {
                cabinetshow: "true"
              }
            });
            // if (!resp.haveMifiBattery && !this.token) {
            //   this.loginTourist(resp.cabinetID)
            // } else {
            //   this.$router.replace({
            //     name: "selectPakage",
            //     query: {
            //       cabinetshow: "true"
            //     }
            //   })
            //   this.$store.commit("homePathName", "homeMap")
            // }
          }
        },
        error => {
          this.$loading(false);
          this.$toast(error);
          this.$router.replace({ name: "homeMap" });
          this.$store.commit("homePathName", "homeMap");
        }
      );
    },
    loginTourist() {
      this.$post(
        `${TOURIST_LOGIN}?code=${this.code}`,
        {},
        resp => {
          if (resp.token && this.browser !== "wechat") {
            this.$store.commit("token", resp.token);
            this.$store.commit("userType", "tourist_login");
            this.loadUser();
            this.$store.commit("homePathName", "selectPakage");
          } else {
            this.$store.commit("homePathName", "homeMap");
            this.onScan(window.location.href);
            // this.onScan('https://saas.dtoolsz.com/#/?qrcode=1728372188')
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    loadUser() {
      this.$loading(true);
      this.$get(
        USER_INFO,
        {},
        res => {
          this.$loading(false);
          if (res.user) {
            this.$store.commit("user", res.user);
            this.onScan(window.location.href);
            // this.onScan('https://saas.dtoolsz.com/#/?qrcode=1728372188')
            // this.$router.replace({
            //   name: "selectPakage",
            //   query: {
            //     cabinetshow: "true"
            //   }
            // })
            // this.$store.commit("homePathName", "selectPakage")
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser();
              })
              .catch(() => {
                this.$store.commit("token", null);
              });
          }
        },
        err => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null);
            this.$router.replace({ name: "homeMap" });
          });
        }
      );
    },
    onScanQr(qr) {
      console.log("qr====", qr);
      this.isPickUpShow = false;
      // let arr = qr.split('/')
      if (qr.includes("1713928951")) {
        qr = "https://wifi.chargenow.top/mifi2/#/?qr=1713928951";
        window.location.href = qr;
      }
      if (qr.includes("1713928925")) {
        qr = "https://wifi.chargenow.top/mifi2/#/?qr=1713928925";
        window.location.href = qr;
      }
      if (qr.includes("1713928954")) {
        qr = "https://wifi.chargenow.top/mifi2/#/?qr=1713928954";
        window.location.href = qr;
      }
      if (qr.includes("1713928931")) {
        qr = "https://wifi.chargenow.top/mifi2/#/?qr=1713928931";
        window.location.href = qr;
      }
      this.onScan(qr);
    }
  },
  created() {
    const _location = window.location;
    if (this.browser === "wechat" && !_location.origin.includes("gzz8j.com")) {
      console.log(
        "_location",
        _location.href,
        _location.href.indexOf("qrcode=") !== -1
      );
      const gzz8jPath = `${process.env.VUE_APP_WE_PAY_URL}/#/`;
      if (this.qrcode) {
        _location.replace(`${gzz8jPath}?qrcode=${this.qrcode}`);
      } else if (_location.href.indexOf("qrcode=") !== -1) {
        let qrArr = _location.href.split("qrcode=");
        let qr = qrArr[qrArr.length - 1];
        _location.replace(`${gzz8jPath}?qrcode=${qr}`);
      } else {
        _location.replace(`${gzz8jPath}`);
      }
      return;
    }
    // this.onScanQr('https://saas.dtoolsz.com/#/?qrcode=1728372188')
    // this.$route.query.qr || this.$route.query.qrcode || this.$route.query.zhcode
    if (this.code) {
      if (_location.href.indexOf("wifi.") !== -1) {
        this.$store.commit("mificode", _location.href);
        this.onScanQr(_location.href);
      } else if (!this.token && _location.href.indexOf("wifi.") === -1) {
        this.loginTourist();
      } else {
        this.$store.commit("urlcode", _location.href);
        this.onScanQr(_location.href);
      }
    } else if (this.urlcode) {
      this.onScanQr(this.urlcode);
    } else {
      this.$router.replace({ name: "homeMap" });
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped></style>
